import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;

  &:not(:nth-last-child(-n+2)) {
    padding-right: ${props => (props.theme.isLarge ? 48 : 20)}px;
  }

  ${props => props.theme.isMobileOrTablet && `
    &:last-child {
      width: 100%;
    }
  `};

  ${props => props.theme.isMobile && `
    min-width: 160px;
    padding: 24px 0 0;
  `};

  ${props => props.theme.isTablet && `
    &:not(:last-child) {
      max-width: 152px;
    }
  `};
`;

const Label = styled.div`
  color: ${props => props.theme.secondaryColor};
  text-transform: uppercase;
  font: ${props => props.theme.fontWeightHeavy} 12px/120% ${props => props.theme.fontFamilyBody};
  ${props => props.theme.isMobileOrTablet && `
    font-size: 11px;
  `};
`;

const Value = styled.div`
  color: ${props => props.theme.bodyColor};
  margin-top: 4px;
  font: ${props => props.theme.fontWeightMedium} 24px/120% ${props => props.theme.fontFamilyBody};
  ${props => props.theme.isMobileOrTablet && `
    font-size: 21px;
  `};
`;

export {
  Container,
  Label,
  Value,
};
